import { PowderStructure } from "./powderStructure";

export interface IPowderStructure {
	text: string;
	value: PowderStructure;
}

const values: IPowderStructure[] = [
	{
		text: "Fein",
		value: PowderStructure.Fine,
	},
	{
		text: "Grob",
		value: PowderStructure.Rough,
	},
	{
		text: "Glatt",
		value: PowderStructure.Smooth,
	},
];

export default values;
